// extracted by mini-css-extract-plugin
module.exports = {"activity_page":"eggGuide_activity_page__i7CgA","btn_box":"eggGuide_btn_box__1O_G2","mask":"eggGuide_mask__1KrYS"};